import React, { useEffect, useState } from 'react';
import Styles from './auth-reset-password-styles.scss';
import { authResetPasswordState } from './components';
import { loginFlowUserState, AuthHeader, AuthLayout, AuthFooter } from '@/presentation/components';
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import StepReset from './components/step-reset';
import StepChanged from './components/step-changed';
import { useSearchParams } from 'react-router-dom';
const AuthResetPassword = ({ validation, authentication }) => {
    const [searchParams] = useSearchParams();
    const resetLoginState = useResetRecoilState(authResetPasswordState);
    const [state, setState] = useRecoilState(authResetPasswordState);
    const setLoginFlowUser = useSetRecoilState(loginFlowUserState);
    const [step, setStep] = useState(0);
    useEffect(() => {
        setState(prev => (Object.assign(Object.assign({}, prev), { verificationCode: searchParams.get('code') })));
        setLoginFlowUser(searchParams.get('user'));
    }, []);
    const validate = (field) => {
        const { newPassword } = state;
        const formData = { newPassword };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.newPasswordError })));
    };
    useEffect(() => resetLoginState(), []);
    useEffect(() => {
        if (state.newPassword)
            validate('newPassword');
    }, [state.newPassword]);
    return (React.createElement(AuthLayout, null,
        React.createElement(AuthHeader, null),
        React.createElement("div", { className: Styles.loginWrap },
            React.createElement("div", { className: Styles.imgWrap },
                React.createElement("img", null)),
            React.createElement("div", { className: Styles.formWrap }, step === 0 ? (React.createElement(StepReset, { validation: validation, authentication: authentication, step: step, setStep: setStep })) : (React.createElement(StepChanged, null)))),
        React.createElement(AuthFooter, null)));
};
export default AuthResetPassword;
